<div class="main-content">
  <div class="ui-g-12 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 margin-align document-upload">
    <label [for]="'float-input-' + fileType" class="ui-g-6" [class.required]="isRequired && !uploadDisabled">
      {{ 'basic-profile.fields.' + fileType | translate }}
    </label>
    <p-fileUpload
      mode="basic"
      uploadIcon="pi pi-upload"
      #form
      styleClass="ui-fileupload-button"
      [name]="fileType"
      [chooseLabel]="'basic-profile.fields.date_upload' | translate"
      [id]="'float-input-' + fileType"
      (onSelect)="uploadHandler($event, fileType, form)"
      [disabled]="checkForAvailableDocuments(fileType) || uploadDisabled || isReadonly"></p-fileUpload>
    <a
      *ngIf="!(!environmentService.technicianRegistration.infoBubbles.showIdCardInfo && fileType === 'id_card_main_fraud')"
      href="javascript:void(0)"
      [pTooltip]="'technician.tooltip.' + fileType | translate"
      tooltipStyleClass="basic-tooltip">
      <i class="pi pi-info-circle hint-icon"></i>
    </a>
  </div>
  <div class="ui-g-12 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 margin-align margin-top-ten">
    <span *ngFor="let document of documents">
      <span *ngIf="document.name === fileType">
        <a href="javascript:void(0)" (click)="downloadFile(document['document_id'], document.filename)">
          {{ document.filename }} ({{ document['filesize'] }})
        </a>
        <a *ngIf="!isReadonly" href="javascript:void(0)" class="margin-vertical-align" (click)="removeFile(document['document_id'])">
          <i class="pi pi-trash"></i>
        </a>
      </span>
    </span>
  </div>
</div>
